import { render, staticRenderFns } from "./authenticationSuccess.vue?vue&type=template&id=5b82f65a&scoped=true"
import script from "./authenticationSuccess.vue?vue&type=script&lang=js"
export * from "./authenticationSuccess.vue?vue&type=script&lang=js"
import style0 from "./authenticationSuccess.vue?vue&type=style&index=0&id=5b82f65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82f65a",
  null
  
)

export default component.exports